import { Component, OnInit } from '@angular/core';
import { RacesService } from './races.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'mc-races',
  templateUrl: './races.component.html',
  styleUrls: ['./races.component.scss']
})
export class RacesComponent implements OnInit {

  racePlans$ = this.racesService.racePlans$;

  isModerable = !!environment.isAdmin;

  constructor(
    public racesService: RacesService
  ) { }

  ngOnInit() {

  }

}
